// extracted by mini-css-extract-plugin
export var parcelRow = "_sg-0";